__turbopack_context__.v({
  "files": "DemoContentLoading-module__nEZJJG__files",
});
